// extracted by mini-css-extract-plugin
export var details = "_k8-0";
export var inspectorPopover = "_k8-1";